export default __webpack_public_path__ + "static/media/phone_group.3603533b.png";